module.exports = __webpack_public_path__ + "img/miscellaneous2.7b836155.png";